import { UIHeading2 } from '@cian/ui-kit';
import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { NewbuildingOffersSkeleton } from '../NewbuildingOffersSkeleton';

interface INewbuildingPromoBuilderOffersLayoutProps {
  carousel?: React.ReactNode;
  showSkeleton: boolean;
  withMargin?: boolean;
}

export function NewbuildingOffersCarouselLayout({
  carousel,
  withMargin,
  showSkeleton,
}: INewbuildingPromoBuilderOffersLayoutProps) {
  return (
    <div
      className={cx(styles['container'], styles['with-banner'], withMargin && styles['with-margin'])}
      data-testid="NewbuildingOffersCarouselLayout"
    >
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <UIHeading2>Похожие квартиры в других ЖК</UIHeading2>
        </div>
        <div className={cx(styles['carousel'], showSkeleton && styles['carousel--skeleton'])}>
          {showSkeleton ? <NewbuildingOffersSkeleton /> : carousel}
        </div>
      </div>
    </div>
  );
}
